import { CellProps } from 'react-table'
import { RiscoActionsCell } from './RiscoActionsCell'
import { RiscoAsoView } from '../../core/_models'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useListView } from '../../core/ListViewProvider'
import {
  PlainHeader,
  SelectionCell,
  SelectionHeader,
  sortableColumn,
  StackedCell,
  TableColumn,
} from '../../../../../../components'
import { FatoresRiscosLabels, formatDateTime } from '../../../../../../../_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'

/** LocalDateTime do backend → "dd/mm/aaaa hh:mm"; ausente vira o traço do StackedCell. */
const dataHora = (date?: string) => (date ? formatDateTime(date) : undefined)

/** Nome do fator (enum → rótulo); cai no `nome` do backend se o enum vier desconhecido. */
const fatorLabel = (risco: RiscoAsoView) =>
  (risco.fatorRisco && FatoresRiscosLabels[risco.fatorRisco]) || risco.nome

export const RiscoColumns = (t: TFunction): ReadonlyArray<TableColumn<RiscoAsoView>> => [
  {
    Header: (props) => (
      <SelectionHeader
        useListView={useListView}
        tableProps={props}
        ariaLabel='Selecionar todos desta página'
      />
    ),
    id: 'selection',
    cellWidth: '48px',
    Cell: ({ row }: CellProps<RiscoAsoView>) => (
      <SelectionCell
        useListView={useListView}
        id={row.original.id}
        ariaLabel={`Selecionar ${fatorLabel(row.original) ?? 'risco'}`}
      />
    ),
  },
  // Fator de risco + descrição (texto livre, truncado com tooltip).
  {
    Header: () => <PlainHeader>Fator de risco / {t('cols.descricao')}</PlainHeader>,
    id: 'fatorRisco',
    Cell: ({ row }: CellProps<RiscoAsoView>) => (
      <StackedCell primary={fatorLabel(row.original)} secondary={row.original.descricao} />
    ),
  },
  // Onde o risco se aplica: setor e cargo, cada um ordenável.
  sortableColumn<RiscoAsoView>({
    id: 'setor.nome',
    cellWidth: '260px',
    useQueryRequest,
    fields: [
      { field: 'setor.nome', label: 'Setor' },
      { field: 'cargo.nome', label: 'Cargo' },
    ],
    Cell: ({ row }: CellProps<RiscoAsoView>) => (
      <StackedCell primary={row.original.setor?.nome} secondary={row.original.cargo?.nome} />
    ),
  }),
  // Última edição em destaque; criação como linha de apoio.
  {
    Header: () => (
      <PlainHeader>
        {t('cols.data.edicao')} / {t('cols.data.criacao')}
      </PlainHeader>
    ),
    id: 'dataAlteracao',
    cellWidth: '188px',
    hideOnMobile: true,
    Cell: ({ row }: CellProps<RiscoAsoView>) => (
      <StackedCell
        tabular
        primary={dataHora(row.original.dataAlteracao)}
        secondary={dataHora(row.original.dataInclusao)}
      />
    ),
  },
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '132px',
    align: 'end',
    Cell: ({ row }: CellProps<RiscoAsoView>) => <RiscoActionsCell risco={row.original} />,
  },
]
